<template>
<div class="d-flex" style="height: 100%">
  <div style="height: 100%; width: 270px" class="left-bar">
    <div class="spacer--xl" />
    <div class="header">
      <img class="logo" :src="selfServiceLogo" />
      <span class="text--m text--bold">{{selfServiceAlias}}</span>
    </div>
    <div class="spacer--xl" />
    <div class="d-flex align-items-center nav-menu" style="cursor: pointer;">
      <img src="~@/assets/icons/home.svg" class="mr-2"/>
      <span class="text--m text--bold">Home</span>
    </div>
  </div>
  <div class="dashboard-main">
    <div class="header">
      <div class="left">
        <span class="text--xl text--bold">My Self-Serve Projects</span>
      </div>
      <div class="right">
        <a-btn class="new-btn" @click="showNewProjectFlow = !showNewProjectFlow">New Self-Service Project</a-btn>
      </div>
    </div>
    <div v-if="loading" class="fill-height d-flex align-items-center flex-column">
      <LoadingIndicator large />
    </div>
    <table v-else-if="project_count" style="width: 100%">
      <col style="width:10%">
      <col style="width:35%">
      <col style="width:15%">
      <col style="width:15%">
      <col style="width:15%">
      <thead>
        <tr class="text--m text--bold">
          <td class="pl-3">Ref.</td>
          <td>Title</td>
          <td>Type</td>
          <td>Date Created</td>
          <td>Progress</td>
        </tr>
      </thead>
      <tbody>
      <tr
        v-for="(project) of projects"
        :key="project.id"
        class="text--m text--bold"
        @click="project.type === 'Self-Service' ? viewProject(project.shortId) : null"
        :style="project.type !== 'Self-Service' ? 'cursor: not-allowed' : null"
      >
        <td>{{project.shortId}}</td>
        <td>{{project.name}}</td>
        <td>{{project.type === 'Self-Service' ? 'Self-Service' : 'Procurement Led'}}</td>
        <td>{{formatDate(project.createdAt, '')}}</td>
        <td><progress-linear :value="!project.actions ? 0 : Math.round((100 * project.completedActions) / project.actions)" /></td>
      </tr>
      </tbody>
    </table>
    <div v-else class="d-flex align-items-center flex-column text--l text--bold"  style="color: #505050">
      <div class="spacer--xxl" />
      <span>You have no open self-service projects</span>
    </div>
  </div>
  <NewProjectFlow
    v-if="showNewProjectFlow"
    @exit="showNewProjectFlow=false"
    @newSelfServiceProject="viewProject($event)"
    @newPipelineProject="getProjects"
  />
</div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn";
import ProgressLinear from "@/components/SelfService/ProgressLinear";
import NewProjectFlow from "@/components/SelfService/NewProjectFlow";
import currency from "@/utils/currency";
import moment from "moment";
import LoadingIndicator from "@/components/LoadingIndicator";
export default {
  name: "SelfServiceDashboard",
  components: {LoadingIndicator, NewProjectFlow, ProgressLinear, ABtn},
  data: () => ({
    showNewProjectFlow: false,
    dataRetrieved: false,
    loading: false
  }),
  async mounted() {
    if (!this.dataRetrieved) {
      await this.getProjects();
      this.dataRetrieved = true;
    }

    this.$ga.page('/self-service');
  },
  methods: {
    async getProjects() {
      try{
        this.loading = true;
        const projects = await this.$store.dispatch('getProjects', {});

        if (projects) {
          await this.$store.dispatch('setTotalProjects', projects.totalSize);
        }
      } catch (e){
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(num, currencyId) {
      currency.locale(currencyId ? this.currencyCodeById(currencyId) : '');
      return currency(num).format('$0a.[0]');
    },
    formatDate(date, fallback) {
      if (!date) {
        return fallback;
      }
      return moment(date).format('D/M/YY');
    },
    viewProject(shortId){
      this.$router.push(`/self-service/${shortId}`)
    }
  },
  computed: {
    projects() {
      if (!this.dataRetrieved) return {};
      return this.$store.getters.projects;
    },
    project_count() {
      return Object.keys(this.projects).length;
    },
    currencyCodeById() {
      return this.$store.getters.currencyCodeById;
    },
    selfServiceLogo(){
      return this.$store.getters.selfServiceLogo;
    },
    selfServiceAlias(){
      return this.$store.getters.selfServiceAlias;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/spacing.scss";
@import "~@/styles/SelfService/colors.scss";
@import "~@/styles/SelfService/effects.scss";

.dashboard-main{
  height: 100%;
  overflow-y: auto;
  flex-grow: 1;
  padding: 0 $spacing--xxl 0;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: $spacing--xl 0;

    > .left {
      flex: 1;
    }

    > .right {
      min-width: 180px;
      display: flex;
    }
  }
}

.logo{
  height: 44px;
  padding: $spacing--xs;
}

.left-bar {
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.nav-menu{
  padding-left: $spacing--l;
  color: $secondary;
}

table{
  border-spacing: 0 $spacing--l;
  border-collapse: separate;

  thead{
    color: $brand-2-disabled;

    td{
      padding: 0 $spacing--m;
    }
  }

  tbody{
    tr{
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 12px;
      cursor: pointer;
    }

    td{
      position: relative;
      background-color: white;
      padding: $spacing--m;

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: $spacing--m;
        top: 25%;
        bottom: 25%;
        width: 1px;
        background-color: #e0e0e0;
      }

      &:first-child{
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }

      &:last-child{
        border-bottom-right-radius: 12px;
        border-top-right-radius: 12px;
      }
    }
  }
}
</style>
